(function () {
  if (!window.ReactNativeWebView) return;

  window.alert = function (message) {
    try {
      window.ReactNativeWebView.postMessage("alert:- " + message);
    } catch (e) {}
  };

  console.log = function (...args) {
    try {
      window.ReactNativeWebView.postMessage(
        "console:- " + JSON.stringify(args)
      );
    } catch (err) {}
  };

  window.open = function (url) {
    try {
      window.ReactNativeWebView.postMessage("open:- " + url);
    } catch (e) {}
  };

  document.addEventListener("copy", function () {
    try {
      const copied = window.getSelection().toString();
      window.ReactNativeWebView.postMessage("copy:- " + copied);
    } catch (e) {}
  });
})();
